import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Import the Toastification plugin and its CSS
import Toast, { POSITION } from "vue-toastification";
import 'vue-toastification/dist/index.css';

// Import other dependencies
import 'primeicons/primeicons.css';
import '@fontsource/montserrat';

const app = createApp(App);

// Configure Vue Toastification
app.use(Toast, {
  position: POSITION.TOP_RIGHT,  // Toast position
  timeout: 5000,                 // Duration for each toast
  closeOnClick: true,            // Close the toast on click
  pauseOnHover: true,            // Pause timer when hovering
  draggable: true,               // Allow dragging to dismiss
  hideProgressBar: false,        // Show the progress bar
  icon: true                     // Show an icon in the toast
});

// Mount the app
app.use(router).mount('#app');

router.afterEach(() => {
  if (sessionStorage.getItem('scrollToTop') === 'true') {
    sessionStorage.removeItem('scrollToTop');
    
    // Use setTimeout to ensure DOM is updated
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  } else {
    // Restore previous scroll position if available
    const scrollPosition = sessionStorage.getItem('previousScrollPosition');
    if (scrollPosition) {
      setTimeout(() => {
        window.scrollTo(0, parseInt(scrollPosition));
        sessionStorage.removeItem('previousScrollPosition');
      }, 0);
    }
  }
});
